module.exports = __webpack_public_path__ + "img/top-bg.1f15c521.jpg";